const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * WHATSAPP EVENTS                                                            *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.whatsappOpened, () => {
    pushEvent(
      createCustomEventGA4('contact', [
        ['action', 'open'],
        ['type', 'whatsapp'],
      ])
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
